module.exports = __webpack_public_path__ + "static/media/Phone-red.d22d89b7.svg";